import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import BASE_URL from "../config";

const SEO = ({ slug = "home" }) => {
  const [meta, setMeta] = useState({
    title: "Softisans",
    description: "Softisans delivers innovative, creative and quality software solutions.",
  });

  useEffect(() => {
    const fetchMeta = async () => {
      try {
        const response = await fetch(`${BASE_URL}api/pages/find-by-slug/${slug}`);
        if (!response.ok) throw new Error("Failed to fetch meta");
        const data = await response.json();

        console.log("SEO API data:", data); // 👈 check what comes from API

        setMeta({
          title: data?.title || data?.pagename || "softisans",
          description: data?.meta || "Softisans delivers innovative, creative and quality software solutions.",
        });
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchMeta();
  }, [slug]);

  return (
    <Helmet>
      {/* Page Title */}
      <title>{meta.title}</title>

      {/* Meta Description */}
      <meta name="description" content={meta.description} key="description"/>

      {/* Optional SEO Enhancements */}
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
    </Helmet>
  );
};

export default SEO;
